import styled from 'styled-components';
import { IonSkeletonText } from '@ionic/react';

export const StyledProfileCardPageHeaderText = styled.h1`
  margin-top: 80px;
`;

export const StyledCardContainer = styled.div`
  margin-top: 28px;
`;

interface ICustomSkeletonProps {
  widthInPx?: number;
  heightInPx?: number;
  marginBottomInPx?: number;
}

export const StyledCustomSkeleton = styled(IonSkeletonText)<ICustomSkeletonProps>`
  border-radius: 4px;
  width: ${(props) => (props.widthInPx ? `${props.widthInPx}px` : '100%')};
  height: ${(props) => (props.heightInPx ? `${props.heightInPx}px` : '1px')};
  margin-bottom: ${(props) => (props.marginBottomInPx ? `${props.marginBottomInPx}px` : '0px')};
`;
